export const samplesWarpShape = {
    warpForm: 'warpForm',
    resetFrom: 'resetFrom',
    archWarpShape: 'archWarpShape',
    bubbleWarpShape: 'bubbleWarpShape',
    waveWarpShape: 'waveWarpShape',
    rectangleWarpShape: 'rectangleWarpShape'
};

export const samplesWarpTransform = {
    [samplesWarpShape.resetFrom]: [
        {
            x: 0,
            y: 0
        },
        {
            x: 0.5,
            y: 0
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 1,
            y: 1
        },
        {
            x: 0.5,
            y: 1
        },
        {
            x: 0,
            y: 1
        },
        {
            x: 1 / 4,
            y: 0
        },
        {
            x: 3 / 4,
            y: 0
        },
        {
            x: 1 / 4,
            y: 1
        },
        {
            x: 3 / 4,
            y: 1
        }
    ],
    [samplesWarpShape.warpForm]: [
        {
            x: 0,
            y: 0
        },
        {
            x: 0.5,
            y: 0.3
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 1,
            y: 1.5
        },
        {
            x: 0.5,
            y: 1
        },
        {
            x: 0,
            y: 1.5
        },
        {
            x: 0.2,
            y: 0.3
        },
        {
            x: 0.8,
            y: 0.3
        },
        {
            x: 0.2,
            y: 1
        },
        {
            x: 0.8,
            y: 1
        }
    ],
    [samplesWarpShape.archWarpShape]: [
        {
            x: 0,
            y: 0
        },
        {
            x: 0.5,
            y: 0
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 1,
            y: 1.5
        },
        {
            x: 0.5,
            y: 1
        },
        {
            x: 0,
            y: 1.5
        },
        {
            x: 0.2,
            y: 0
        },
        {
            x: 0.8,
            y: 0
        },
        {
            x: 0.2,
            y: 1
        },
        {
            x: 0.8,
            y: 1
        }
    ],
    [samplesWarpShape.bubbleWarpShape]: [
        {
            x: 0,
            y: 0.4
        },
        {
            x: 0.5,
            y: 0
        },
        {
            x: 1,
            y: 0.4
        },
        {
            x: 1,
            y: 1.1
        },
        {
            x: 0.5,
            y: 1.5
        },
        {
            x: 0,
            y: 1.1
        },
        {
            x: 0.2,
            y: 0
        },
        {
            x: 0.8,
            y: 0
        },
        {
            x: 0.2,
            y: 1.5
        },
        {
            x: 0.8,
            y: 1.5
        }
    ],
    [samplesWarpShape.waveWarpShape]: [
        {
            x: 0,
            y: 0.65
        },
        {
            x: 0.5,
            y: 0.3
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 1,
            y: 0.65
        },
        {
            x: 0.5,
            y: 1
        },
        {
            x: 0,
            y: 1.5
        },
        {
            x: 0.2,
            y: 0.3
        },
        {
            x: 0.8,
            y: 0.3
        },
        {
            x: 0.2,
            y: 1
        },
        {
            x: 0.8,
            y: 1
        }
    ],
    [samplesWarpShape.rectangleWarpShape]: [
        {
            x: 0,
            y: 0
        },
        {
            x: 0.5,
            y: 0
        },
        {
            x: 1,
            y: 0
        },
        {
            x: 1,
            y: 1
        },
        {
            x: 0.5,
            y: 1
        },
        {
            x: 0,
            y: 1
        },
        {
            x: 1 / 4,
            y: 0
        },
        {
            x: 3 / 4,
            y: 0
        },
        {
            x: 1 / 4,
            y: 1
        },
        {
            x: 3 / 4,
            y: 1
        }
    ]
};

export const getSampleWarpShape = (type) => {
    return samplesWarpTransform[type || samplesWarpShape.warpForm] || [];
};
